import ThemePickerPage from "./ThemePickerPageV2";
export default ThemePickerPage;